/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastattendance1Inputs */

const de__field_lastattendance1 = /** @type {(inputs: _Field_Lastattendance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Anwesenheit`)
};

/**

* @param {_Field_Lastattendance1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastattendance1 = /** @type {((inputs?: _Field_Lastattendance1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastattendance1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastattendance1(inputs)
});
export { _field_lastattendance1 as "_field_lastAttendance" }